// extracted by mini-css-extract-plugin
export default {"wrapAddressOkImg":"AddressFieldPreView_wrapAddressOkImg__L20ph","addressOkImg":"AddressFieldPreView_addressOkImg__ufk6U"};